export const percentage = (value) => {
    const roundedValue = Math.round((value + Number.EPSILON) * 100) / 100;
    if (roundedValue < 0.01) {
        return '<0.01%';
    }
    return `${roundedValue.toFixed(2)}%`;
};
